import { useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { Links } from "../../helpers/Links";
import { DeXuatNhuCauTaiSan, TrangThaiDeXuatNhuCau } from "../../models/taisan/DeXuatNhuCauTaiSan";
import LoadingDetailPage from "../../modules/loading/LoadingDetailPage";
import { layChiTietDeXuat, trinhDuyetDeXuat } from "../../services/deXuatNhuCauTaiSan";
import { useSelector } from "react-redux";
import { responseStatus } from "../../constants";
import LuuDeXuatNhuCauBox from "./LuuDeXuatNhuCauBox";

const ChiTietDeXuatNhuCau = () => {
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const isThemMoi = !id;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [deXuat, setDeXuat] = useState<DeXuatNhuCauTaiSan | null>(null);

    const canSubmit = !!deXuat && (deXuat.idNVKhoiTao === user?.idNhanVien || deXuat.idNVKhoiTao === user?.id) && [
        TrangThaiDeXuatNhuCau.KhoiTao,
        TrangThaiDeXuatNhuCau.ThuHoi,
        TrangThaiDeXuatNhuCau.LanhDaoPhongTraLai,
    ].includes(deXuat.trangThai);

    const loadChiTiet = async () => {
        if (!id) return;

        try {
            setIsLoading(true);
            const result = await layChiTietDeXuat(parseInt(id));
            setDeXuat(result);
        } catch (error: any) {
            toast.error("Lỗi khi tải chi tiết đề xuất: " + (error.message || error));
            navigate(Links.DeXuatNhuCauTaiSan.DanhSach);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            loadChiTiet();
        } else {
            setDeXuat(null);
        }
    }, [id]);

    const handleTrinhDuyet = async () => {
        if (!deXuat?.id) {
            return;
        }

        try {
            const response = await trinhDuyetDeXuat(deXuat.id);
            if (response.trangThai === responseStatus.thanhCong) {
                toast.success("Trình lãnh đạo phòng thành công");
                navigate(`${Links.DeXuatNhuCauTaiSan.Xem}?id=${deXuat.id}`);
            } else {
                toast.error(response.thongBao || "Trình lãnh đạo phòng không thành công");
            }
        } catch (error: any) {
            toast.error(error.message || "Lỗi khi trình lãnh đạo phòng");
        }
    };

    if (isLoading && id) {
        return <LoadingDetailPage title={isThemMoi ? "Thêm mới đề xuất nhu cầu tài sản" : "Chỉnh sửa đề xuất nhu cầu tài sản"} />;
    }

    return (
        <section>
            <ContentHeader title={isThemMoi ? "Thêm mới đề xuất nhu cầu tài sản" : "Chỉnh sửa đề xuất nhu cầu tài sản"} />
            <Row>
                <Col span={24}>
                    <div className="card">
                        <div className="card-body">
                            {canSubmit && (
                                <div style={{ marginBottom: 16, textAlign: "right" }}>
                                    <Button type="primary" icon={<SendOutlined />} onClick={handleTrinhDuyet}>
                                        Trình lãnh đạo phòng
                                    </Button>
                                </div>
                            )}
                            <LuuDeXuatNhuCauBox
                                modelProps={deXuat}
                                onSubmit={() => navigate(Links.DeXuatNhuCauTaiSan.DanhSach)}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default ChiTietDeXuatNhuCau;
